import React from 'react';
import {
  IconConnectedApps,
  IconGroup,
  IconNote,
  IconReportsAvgGlucose,
  IconSettingsOutlined,
  SideNavigation,
} from '@adc/parallax-component-library';
import { IconPhosphorAddressBookTabsRegular } from '@adc/parallax-icons/phosphor';
import './SideNav.scss';
import { useNavigate } from 'react-router';
import i18n from '../../utilities/i18n';

export default function SideNav() {
  const navigate = useNavigate();

  const navItems = [
    {
      label: i18n.t('SideNavigation.dashboard'),
      key: 'dashboard',
      icon: <IconReportsAvgGlucose size="XS" color="$text.80" />,
    },
    {
      label: i18n.t('SideNavigation.studies'),
      key: 'studies',
      icon: <IconNote size="XS" color="$text.80" />,
    },
    {
      label: i18n.t('SideNavigation.admin'),
      key: 'admin',
      icon: <IconSettingsOutlined size="XS" color="$text.80" />,
      items: [
        {
          label: i18n.t('SideNavigation.manageOrganizations'),
          key: 'organizations',
          icon: <IconConnectedApps size="XS" color="$text.80" />,
        },
        {
          label: i18n.t('SideNavigation.manageUsers'),
          key: 'accounts',
          icon: <IconGroup size="XS" color="$text.80" />,
        },
        {
          label: i18n.t('SideNavigation.roleAssignments'),
          key: 'role-assignments',
          icon: (
            <IconPhosphorAddressBookTabsRegular size="XS" color="$text.80" />
          ),
        },
      ],
    },
  ];

  return (
    <div className="side-navigation">
      <SideNavigation
        height="100%"
        items={navItems}
        onItemSelected={(key) => navigate(`/${key}`)}
        testID="side-nav"
      />
    </div>
  );
}
